import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SetIsFilterNavOpenParameter } from "@store/Framework/Store/Toolkit/Pages/ProductList/Handlers/setIsFilterNavOpen";
import { Draft } from "immer";

const initialState: Toolkit.Store.Toolkit.Pages.ProductList.State = {
    isFilterNavOpen: false,
};

const actions = {
    "Toolkit/Pages/ProductList/SetIsFilterNavOpen": (
        draft: Draft<Toolkit.Store.Toolkit.Pages.ProductList.State>,
        action: SetIsFilterNavOpenParameter,
    ) => {
        draft.isFilterNavOpen = action.isOpen;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type ToolkitProductListActions = Parameters<typeof reducer>[1];
export default reducer;
